import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useTheme, alpha } from "@mui/material/styles";
import MDTypography from "components/MDTypography";

export default function StepContainer({ title, hint, children }) {
  const theme = useTheme();
  return (
    <Box sx={{ width: "100%" }}>
      <MDTypography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 0.5 }}>
        {title}
      </MDTypography>
      {hint ? (
        <MDTypography variant="caption" color="text.secondary" sx={{ display: "block", mb: 2 }}>
          {hint}
        </MDTypography>
      ) : (
        <Box sx={{ mb: 2 }} />
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.25,
          maxHeight: { xs: "52vh", sm: "none" },
          overflowY: { xs: "auto", sm: "visible" },
          pr: { xs: 0.5, sm: 0 },
          "&::-webkit-scrollbar": { width: 6 },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: 3,
            bgcolor: alpha(theme.palette.primary.main, 0.25),
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

StepContainer.propTypes = {
  title: PropTypes.node.isRequired,
  hint: PropTypes.node,
  children: PropTypes.node.isRequired,
};

StepContainer.defaultProps = {
  hint: null,
};
